import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

export const AlertModal = (props) => {
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      variant="warning"
    >
      <Modal.Header  closeButton={props.onHide}>
        <Modal.Title c id="contained-modal-title-vcenter">
          {props.heading}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          {props.bodyMessage}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Ok</Button>
      </Modal.Footer>
    </Modal>
  );
}